import React from 'react';
import { useSelector } from 'react-redux';

import CostingCard from '@components/CostingCard';

import InnerTabsForBuyerDesign from '@features/costing/components/InnerTabsForBuyerDesign';

import { checkAnyUserType } from '@utils/Util';

const RequestViewCostingItems = () => {
	const listOfCosting = useSelector((store) => store.filterResponseStore);
	const acceptedRoles = ['COSTING_MANAGER', 'ADMIN', 'MANAGEMENT', 'SUPPLY_CHAIN'];

	const renderBuyerDesign = () => {
		return listOfCosting?.data?.map((item, idx) => {
			return (
				<div className="sample-items-row" key={`costing_item_${idx}`}>
					<CostingCard costingItem={item} />
				</div>
			);
		});
	};
	return (
		<div className="data-table">
			{checkAnyUserType(acceptedRoles) && (
				<div className="inner-tabs mb-3">
					<InnerTabsForBuyerDesign />
				</div>
			)}

			<div className="sample-dashboard-container">{renderBuyerDesign()}</div>
		</div>
	);
};

export default RequestViewCostingItems;
